import { useEffect, useRef } from 'react';
import Header from './components/Header';
import Hero from './components/Hero';
import IndexSection from './components/IndexSection';
import MediaSection from './components/MediaSection';
import CommentsSection from './components/CommentsSection';
import AboutSection from './components/AboutSection';
import CarouselSection from './components/CarouselSection';
import AppSection from './components/AppSection';
import TopicsSection from './components/TopicsSection';
import UpdatesSection from './components/UpdatesSection';
import RankingSection from './components/RankingSection';
import ContactSection from './components/ContactSection';
import CardsSection from './components/CardsSection';
import FaqSection from './components/FaqSection';
import FeaturesSection from './components/FeaturesSection';
import Footer from './components/Footer';

function ScrollAnimatedSection({ children, className = '' }: { children: React.ReactNode; className?: string }) {
  const ref = useRef<HTMLDivElement>(null);

  useEffect(() => {
    const el = ref.current;
    if (!el) return;

    const observer = new IntersectionObserver(
      ([entry]) => {
        if (entry.isIntersecting) {
          el.classList.add('animate-fade-in-up');
          observer.unobserve(el);
        }
      },
      { threshold: 0.08, rootMargin: '0px 0px -30px 0px' }
    );

    observer.observe(el);
    return () => observer.disconnect();
  }, []);

  return (
    <div ref={ref} className={`opacity-0 ${className}`}>
      {children}
    </div>
  );
}

export default function Home() {
  return (
    <div className="min-h-screen bg-background-50">
      <Header />

      <main>
        <Hero />

        <ScrollAnimatedSection>
          <IndexSection />
        </ScrollAnimatedSection>

        <ScrollAnimatedSection>
          <MediaSection />
        </ScrollAnimatedSection>

        <ScrollAnimatedSection>
          <CommentsSection />
        </ScrollAnimatedSection>

        <ScrollAnimatedSection>
          <AboutSection />
        </ScrollAnimatedSection>

        <ScrollAnimatedSection>
          <CarouselSection />
        </ScrollAnimatedSection>

        <ScrollAnimatedSection>
          <AppSection />
        </ScrollAnimatedSection>

        <ScrollAnimatedSection>
          <TopicsSection />
        </ScrollAnimatedSection>

        <ScrollAnimatedSection>
          <UpdatesSection />
        </ScrollAnimatedSection>

        <ScrollAnimatedSection>
          <RankingSection />
        </ScrollAnimatedSection>

        <ScrollAnimatedSection>
          <ContactSection />
        </ScrollAnimatedSection>

        <ScrollAnimatedSection>
          <CardsSection />
        </ScrollAnimatedSection>

        <ScrollAnimatedSection>
          <FaqSection />
        </ScrollAnimatedSection>

        <ScrollAnimatedSection>
          <FeaturesSection />
        </ScrollAnimatedSection>
      </main>

      <Footer />
    </div>
  );
}